import React from "react";
import { EstoquesMedicamentoPage } from "./estoquesMedicamento.page";
import { EstoquesMedicamentoProvider } from "./context/estoques-medicamento-context";

export function EstoquesMedicamentoFactory() {
    return (
        <EstoquesMedicamentoProvider>
            <EstoquesMedicamentoPage></EstoquesMedicamentoPage>
        </EstoquesMedicamentoProvider>
    );
}
